import api from './api';

// 获取标签服务
const tagService = {
  // 获取标签列表（分页）
  getTags: async (params = {}) => {
    try {
      const defaultParams = {
        page: 0,
        size: 10
      };
      const requestParams = { ...defaultParams, ...params };
      const response = await api.get('/tags', { params: requestParams });
      console.log('获取标签列表响应:', response.data);
      return response.data.content || response.data;
    } catch (error) {
      console.error('获取标签列表错误:', error);
      throw error;
    }
  },
  
  // 获取所有标签（不分页，一次性获取较多数据）
  getAllTags: async () => {
    try {
      // 请求较大数量的标签数据，适用于下拉选择等场景
      const response = await api.get('/tags', { 
        params: { 
          page: 0, 
          size: 1000 // 设置一个足够大的数量
        } 
      });
      console.log('获取所有标签响应:', response.data);
      return response.data.content || response.data;
    } catch (error) {
      console.error('获取所有标签错误:', error);
      throw error;
    }
  }
};

export default tagService; 